import { getCurrentIntl } from 'i18n/util/currentIntl'
import { formatOccupantsShort } from 'lib/offer/occupancyUtils'

export function getOccupancyText(rooms: Array<App.Occupants>, saleUnit?: string) {
  const intl = getCurrentIntl()
  let text = formatOccupantsShort(rooms)
  if (!!saleUnit && !!rooms.length) {
    text = intl.formatMessage(
      {
        id: 'cvqQxq3/Vu',
        defaultMessage: '{occupancyText} · {saleUnitLabel}',
        description: 'Recommendation occupancy text with sale unit count',
      },
      {
        occupancyText: text,
        saleUnitLabel: intl.formatMessage({
          id: '15lMPlOYhx',
          defaultMessage: '{count, plural, one {# room} other {# rooms}}',
          description: 'Pluralized sale unit count for recommendation occupancy',
        }, { count: rooms.length }),
      },
    )
  }
  return text
}

export function getBnblOccupancyText(numberOfRooms: number, saleUnit?: string) {
  if (!!saleUnit && !!numberOfRooms) {
    const intl = getCurrentIntl()
    return intl.formatMessage({
      id: '9G9E7Nzqzk',
      defaultMessage: '{count, plural, one {# room} other {# rooms}}',
      description: 'Pluralized sale unit count for BNBL occupancy',
    }, { count: numberOfRooms })
  }
}
